<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.934 23.467V23.467C30.934 27.591 27.591 30.934 23.467 30.934V30.934C19.343 30.934 16 27.591 16 23.467V23.467C16 19.343 19.343 16 23.467 16V16C27.591 16 30.934 19.343 30.934 23.467Z"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32 32L28.75 28.75"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.7885 23.4668H20.1465"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.4688 20.1451V26.7871"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
